import * as angular from 'angular';
import * as _ from 'lodash';

import { toHierarchy } from '../mappers';
import { ComponentDefinition, VariableTableViewModel } from '../../../../models';

class HierarchicalViewController implements angular.IComponentController {
    viewModels: VariableTableViewModel[];
    nested: { key: string, values: VariableTableViewModel[] }[];
    isLoading: boolean;
    loadingMessage: string;
    visibility: { [key: string]: boolean };
    sharedController: {
        expandAll: () => void,
        collapseAll: () => void,
        isExpandAll: boolean,
        isCollapseAll: boolean
    };
    isEditMode: boolean;
    static $inject = [];

    $onInit() {
        this.sharedController = {
            expandAll: this.expandAll.bind(this),
            collapseAll: this.collapseAll.bind(this),
            isExpandAll: true,
            isCollapseAll: false
        };
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['viewModels'] && changesObj['viewModels'].currentValue) {
            this.isLoading = true;
            const nested = toHierarchy(this.viewModels);
            const visibility = {};
            nested.forEach(n => {
                visibility[n.key] = true;
            });
            this.visibility = visibility;
            this.nested = nested;
            this.isLoading = false;
        }
    }

    expandAll() {
        const visibility = angular.copy(this.visibility);
        for (const key of Object.keys(visibility)) {
            visibility[key] = true;
        }
        this.visibility = visibility;
        this.sharedController.isExpandAll = true;
        this.sharedController.isCollapseAll = false;
    }

    collapseAll() {
        const visibility = angular.copy(this.visibility);
        for (const key of Object.keys(visibility)) {
            visibility[key] = false;
        }
        this.visibility = visibility;
        this.sharedController.isExpandAll = false;
        this.sharedController.isCollapseAll = true;
    }

}

export const wtHierarchicalView: ComponentDefinition = {
    componentId: 'wtHierarchicalView',
    controller: HierarchicalViewController,
    template: require('./hierarchicalView.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        viewModels: '<',
        sharedController: '=?',
        isEditMode: '=?',
        onSave: '&?',
        onEdit: '&?',
        onCancel: '&?'
    }
};
